/** Readers for music content (or its card), shared by the frame, its card and its paint. */
import { asString } from "@/components/shapes/shared/plain-record";

export interface MusicFields {
  track: string;
  artist: string;
  /** The Spotify track id the player plays, else "". */
  embedId: string;
}

export function musicFields(source: Record<string, unknown>): MusicFields {
  return {
    track: asString(source.track),
    artist: asString(source.artist),
    embedId: asString(source.embedId),
  };
}

/** Whether the track has a name to show; else the card and its window are plain. */
export function hasTrack(fields: MusicFields): boolean {
  return fields.track !== "" || fields.artist !== "";
}
